import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useDeleteAgenda() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, { reportId: string; familyId?: string }>({
    mutationFn: ({ reportId, familyId }: { reportId: string; familyId?: string }) =>
      api.delete(
        familyId
          ? `families/${familyId}/meeting-agendas/${reportId}`
          : `meeting-agendas/${reportId}`,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['meeting-agendas'] });
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const deleteMeetingAgenda = async (reportId: string) => {
    return mutateAsync({ reportId });
  };

  const deleteFamilyMeetingAgenda = async (familyId: string, reportId: string) => {
    return mutateAsync({ reportId, familyId });
  };

  return {
    deleteMeetingAgenda,
    deleteFamilyMeetingAgenda,
    error,
    isLoading,
    reset,
  };
}
